module.exports = __webpack_public_path__ + "img/image99.87455dd7.png";